import React from 'react'
import SEO from '../../common/SEO';
import Layout from '../../common/Layout';
import Banner from '../../components/programs-section/our-programs/Banner';
import ProgramsListing from '../../components/programs-section/our-programs/ProgramsListing';

const OurPrograms = () => {
  return (
    <>
      <SEO
        title="Our Programs"
        description="Unlock your potential in research or work opportunities with M2M Tech!"
      />
      <Layout>
        <Banner />
        <ProgramsListing />
      </Layout>
    </>
  )
}

export default OurPrograms;